// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import Field from './Field';

class FieldDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDropdown: false,
    };

    this.handleToggleDropdown = this.handleToggleDropdown.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setHandleClickOutside = this.setHandleClickOutside.bind(this);
  }

  handleToggleDropdown() {
    const dropdownIsShowing = this.state.showDropdown;

    this.setState(oldState => ({
      ...oldState,
      showDropdown: !dropdownIsShowing,
    }));

    if (dropdownIsShowing)
      document.removeEventListener('click', this.handleClickOutside);
    else this.setHandleClickOutside();
  }

  handleButtonClick(event) {
    const hasAnyDropdownOpen = document.querySelector(
      '.filter-v2__dropdown-wrapper[data-showing-dropdown="true"]',
    );
    if (!hasAnyDropdownOpen) event.stopPropagation();

    this.handleToggleDropdown();
  }

  handleClickOutside(event) {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      this.handleToggleDropdown();
    }
  }

  setHandleClickOutside() {
    document.addEventListener('click', this.handleClickOutside, false);
  }

  render() {
    const { showDropdown } = this.state;
    const {
      fieldTitle,
      customClasses,
      dropdownCustomClasses,
      children,
      disabled,
    } = this.props;

    return (
      <div
        className={`filter-v2__dropdown-wrapper ${customClasses}`}
        data-showing-dropdown={showDropdown}
      >
        <Field
          customClasses="filter-v2__dropdown-field"
          iconRight="arrow-d"
          handleClick={this.handleButtonClick}
          disabled={disabled}
        >
          {fieldTitle}
        </Field>

        {showDropdown && (
          <div
            className={`filter-v2__dropdown ${dropdownCustomClasses}`}
            ref={dropdownRef => {
              this.dropdownRef = dropdownRef;
            }}
          >
            {children}
          </div>
        )}
      </div>
    );
  }
}

FieldDropdown.defaultProps = {
  fieldTitle: '',
  children: null,
  customClasses: '',
  dropdownCustomClasses: '',
  disabled: false,
};

FieldDropdown.propTypes = {
  fieldTitle: PropTypes.string,
  children: PropTypes.element,
  customClasses: PropTypes.string,
  dropdownCustomClasses: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FieldDropdown;
